import { render, staticRenderFns } from "./LoginModal.vue?vue&type=template&id=be0836c2&scoped=true"
import script from "./LoginModal.vue?vue&type=script&lang=ts"
export * from "./LoginModal.vue?vue&type=script&lang=ts"
import style0 from "./LoginModal.vue?vue&type=style&index=0&id=be0836c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be0836c2",
  null
  
)

export default component.exports